
import { defineComponent } from 'vue'
import TimelineEventList from "~/components/about/TimelineEventList.vue";
export default defineComponent({
  name: 'TimelineItem',
  components: { TimelineEventList },
  props: ['acfData'],
})
